import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWizard } from '../wizard/WizardContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredStep?: 'load' | 'crop';
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredStep,
  redirectTo = '/'
}) => {
  const navigate = useNavigate();
  const { state } = useWizard();

  useEffect(() => {
    // Check if route access is allowed based on step completion
    if (requiredStep === 'load') {
      // For crop step, need load to be completed
      if (!state.completedSteps.includes('load') || !state.uploadedFile || !state.selectedCountry) {
        navigate(redirectTo);
        return;
      }
    } else if (requiredStep === 'crop') {
      // For save step, need crop to be completed
      if (!state.completedSteps.includes('crop') || !state.finalPhoto || !state.selectedCountry) {
        // Redirect to crop if load is done, otherwise to load
        if (state.completedSteps.includes('load') && state.uploadedFile && state.selectedCountry) {
          navigate('/crop.html');
        } else {
          navigate('/');
        }
        return;
      }
    }
  }, [requiredStep, state.completedSteps, state.uploadedFile, state.selectedCountry, state.finalPhoto, navigate, redirectTo]);

  // Don't render children if protection conditions aren't met
  if (requiredStep === 'load') {
    if (!state.completedSteps.includes('load') || !state.uploadedFile || !state.selectedCountry) {
      return null;
    }
  } else if (requiredStep === 'crop') {
    if (!state.completedSteps.includes('crop') || !state.finalPhoto || !state.selectedCountry) {
      return null;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;